<ng-content select="[custom-error-above]"></ng-content>
<div class="error" *ngIf="showGenericError">
  <p>Unfortunately, we couldn't find a match for that information in our system.</p>
  <ul class="error-bullets">
    <li>Check that you entered the information correctly.</li>
    <li>Make sure you're using the information that your sponsoring organization would have for you.</li>
    <li>
      If you're still having trouble, contact us at
      <a
        class="error-email-link"
        href="mailto:support@kumanu.com?Subject={{ productName }}%20Support%20Request%20-%20Eligibility"
        target="_blank">
        support@kumanu.com
      </a>
    </li>
  </ul>
</div>
<ng-content select="[custom-error-below]"></ng-content>
